import React, { } from "react";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faTrash, faEdit, faTrashRestore } from '@fortawesome/free-solid-svg-icons';
import './index.scss';
import ImagePlaceholder from "../../../../components/common/ImagePlaceholder";
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2';
const MySwal = withReactContent(Swal)
const LocationPic = ({ info, _editItem, _deleteAndRestore, _viewInfo }) => {


	/**
	 * @description method call to soft delete Operator 
	 * @returns 
	 */
    const deleteLocation  = (status,id) => {
        MySwal.fire({
            title: 'Are you sure?',
            text: "You want to archive this work group ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, archive it!'
        }).then((result) => {

            if (result.isConfirmed) {
                _deleteAndRestore(status,id)
                MySwal.fire(
                    'Archived!',
                    'work group has been archived.',
                    'success'
                )
            }
        })

    }


    /**
	 * @description method call to restore location 
	 * @returns 
	 */
    const restoreLocation  = (status,id) => {
        MySwal.fire({
            title: 'Are you sure?',
            text: "You want to restore this work group ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, restore it!'
        }).then((result) => {

            if (result.isConfirmed) {
                _deleteAndRestore(status,id)
                MySwal.fire(
                    'Restored!',
                    'Work Group has been restored.',
                    'success'
                )
            }
        })

    }

    return (
        <>
            <div className="locaton-pic position-relative">
                <div className="btns-cell position-absolute">
                    {!info.deleted ? (<>
                        <Button color="link" className="rounded-circle p-0" onClick={() => { _viewInfo(info?._id) }} data-toggle="tooltip" data-placement="top" title={'View'}>
                            <FontAwesomeIcon icon={faEye} />
                        </Button>
                        <Button color="link" className="rounded-circle p-0" onClick={() => { deleteLocation(true,info?._id)}} data-toggle="tooltip" data-placement="top" title={'Archive'}>
                            <FontAwesomeIcon icon={faTrash} />
                        </Button>
                        <Button color="link" className="rounded-circle p-0" onClick={() => { _editItem(info) }} data-toggle="tooltip" data-placement="top" title={'Edit'} >
                            <FontAwesomeIcon icon={faEdit} />
                        </Button>
                    </>) :
                        (<Button color="link" className="rounded-circle p-0" onClick={() => { restoreLocation(false, info?._id)}} data-toggle="tooltip" data-placement="top" title={'Restore'}>
                            <FontAwesomeIcon icon={faTrashRestore} />
                        </Button>)}
                </div>
                {info?.blob_name ?
                            <img className='img-fluid' src={info.blob_name} alt="List" />
                            : <ImagePlaceholder />
                        }
            </div>
        </>
    )
};
export default LocationPic;